// UI
import Badge from '../ui/Badge'

// Lib
import inventoryStatus from '../../lib/inventory'

// Icons
import {
    IconCheck,
    IconAlertSquareRounded,
    IconAlarm,
    IconQuestionMark,
} from '@tabler/icons-react'

// Dayjs
import dayjs from 'dayjs'

// Mantine
import { Tooltip } from '@mantine/core'

const InventoryStatusBadge = ({
    status,
    last_inventory_days,
    needs_inventory = true,
}) => {
    if (status.code === 'done' && needs_inventory) {
        return (
            <div className="flex items-center gap-1 text-green-600 bg-green-50 border border-green-200 px-1 py-1 rounded-md text-xs">
                <IconCheck size={14} />

                <span className="hidden lg:block">
                    Dans {-last_inventory_days} jours
                </span>
            </div>
        )
    } else if (status.code === 'soon_to_do' && needs_inventory) {
        return (
            <div className="flex items-center gap-1 text-orange-600 bg-orange-50 border border-orange-200 px-1 py-1 rounded-md text-xs">
                <IconAlarm size={14} />

                <span className="hidden lg:block">
                    À faire avant {-last_inventory_days} jours
                </span>
            </div>
        )
    } else if (status.code === 'to_do' && needs_inventory) {
        return (
            <div className="flex items-center gap-1 text-red-600 bg-red-50 border border-red-200 px-1 py-1 rounded-md text-xs">
                <IconAlertSquareRounded size={14} />

                {last_inventory_days < 1000 && (
                    <span className="hidden lg:block">
                        Depuis {last_inventory_days} jours
                    </span>
                )}

                {last_inventory_days >= 1000 && (
                    <span className="hidden lg:block">À faire</span>
                )}
            </div>
        )
    } else {
        return (
            <div className="flex items-center gap-1 text-gray-600 bg-gray-50 border border-gray-200 px-1 py-1 rounded-md text-xs">
                <IconQuestionMark size={14} />
            </div>
        )
    }
}

export default function ComponentInventoryStatus({
    last_inventory_days,
    last_inventory_date,
    needs_inventory = true,
}) {
    let last_inventory_days_set = last_inventory_days || 1000

    const status = inventoryStatus(last_inventory_days_set)

    const last_inventory_date_formatted = last_inventory_date
        ? 'Verifié ' +
          dayjs(last_inventory_date).fromNow() +
          dayjs(last_inventory_date).format('[, le] dddd LL à HH:mm')
        : 'Jamais inventorié'

    if (!needs_inventory) {
        return <span className="text-sm text-gray-400">-</span>
    }

    return (
        <div className="flex items-center gap-2">
            <Tooltip label={last_inventory_date_formatted}>
                <div>
                    <InventoryStatusBadge
                        status={status}
                        last_inventory_days={last_inventory_days_set}
                        needs_inventory={needs_inventory}
                    />
                </div>
            </Tooltip>
        </div>
    )
}
